import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files directly for better bundling
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  }
};

i18n
  // Load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // Learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // Detect user language
  // Learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Use resources directly instead of loading from backend for better performance
    resources,
    
    // Language detection order and caches
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'], // Languages to not persist to cache
      cookieMinutes: 160,
      cookieDomain: 'myDomain',
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      lookupSessionStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      // htmlTag document.documentElement.setAttribute('lang', lng)
      htmlTag: document.documentElement,
      // only used if location would not work
      checkWhitelist: true,
    },

    // Default language if no language is detected
    fallbackLng: 'en',
    
    // Debug mode (disable in production)
    debug: process.env.NODE_ENV === 'development',

    // Common options
    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Backend options for loading translations
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // React options
    react: {
      // Wait for all translations to be loaded before rendering
      wait: true,
      // Bind i18n instance to React component tree
      bindI18n: 'languageChanged',
      // Bind store to React component tree
      bindI18nStore: '',
      // Re-render when language changes
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      // Options for useTranslation hook
      useSuspense: false,
    },

    // Performance optimizations
    cleanCode: false,
    saveMissing: process.env.NODE_ENV === 'development',
    saveMissingTo: 'current',
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} for language: ${lng}`);
      }
    },

    // Supported languages
    supportedLngs: ['en', 'de'],
    nonExplicitSupportedLngs: true,
  });

export default i18n;